import { useEffect } from 'react'
import { App, Form, FormInstance, Input } from 'antd'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { useAppSelector } from '../../../store/hooks'
import i18n from '../../../i18n/setupLocalization'
import { requiredRule, stringRule } from '../../../helpers/rules'
import TextArea from 'antd/es/input/TextArea'
import { getMetadata } from '../../../modules/sbrm/SBRMModel'
import { MetaDataKey } from '../../../modules/sbrm/models/MetaData'
import ButtonsEditor from '../button/ButtonsEditor'
import AttachmentEditor, {
  validateFileList,
} from '../attachment/AttachmentEditor'

interface Props {
  form: FormInstance
}

const Create = ({ form }: Props) => {
  const { message } = App.useApp()
  const { isOpen: SBRMIsOpen, metadata } = useAppSelector((state) => state.SBRM)

  useEffect(() => {
    if (!SBRMIsOpen) {
      // We want to trigger only the reset
      // when the SBRM opens
      return
    }
    form.setFieldValue(
      'forFollower',
      getMetadata(metadata, MetaDataKey.forFollower)
    )
    form.setFieldValue(
      'automation',
      getMetadata(metadata, MetaDataKey.automationId)
    )
  }, [SBRMIsOpen])

  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={(changed, values) => {
        if (changed.hasOwnProperty('file')) {
          try {
            validateFileList(form, changed.file)
          } catch (error) {
            message.error(error as string)
          }
        }
      }}
    >
      <Form.Item
        name="message"
        label={'Message'}
        rules={[requiredRule(), stringRule()]}
      >
        <TextArea rows={8} />
      </Form.Item>
      <Form.Item
        name="forFollower"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="automation"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <ButtonsEditor />
      <AttachmentEditor />
      {/* <Form.Item
        name="percentage"
        label={'Percentage'}
        rules={[requiredRule(), numberRule()]}
      >
        <InputNumber min={0} max={100} suffix={'%'} />
      </Form.Item> */}
    </Form>
  )
}

export default Create
